import React, { Component,useState } from 'react'

function MoreInfo (){
 const [show, setShow] = useState(false);
    return (
        <>
        <button class="btn" style={{cursor:"pointer"}} onClick={() => setShow(!show)}>
          {show ? "Close" : "Read More"}
        </button>
  
        {show && <p>An avid gamer and junior software developer with an insatiable curiosity. I love exploring everything from small indie games to large AAA titles. When not coding or gaming, I enjoy walking and spending time with family. My older brother's encouragement has been crucial in my success, pushing me to achieve great heights in both gaming and programming. With a passion for innovation, I'm set to make a mark in the tech world. </p>}
      </>
    )
  
}
export default MoreInfo;